import { useEvent } from '~features/events/hooks/useEvent';

const Events = {
  BannerShown: 'Trial: Banner Shown',
  BannerClosed: 'Trial: Banner Closed',
  FeedbackConverted: 'Trial: Survey Converted Submitted',
  FeedbackChurn: 'Trial: Survey Not Converted Submitted',
  FeedbackNotEnoughFeatures: 'Trial: Survey Not Enough Features Submitted',
  ApplyDiscountClicked: 'Trial: Apply Discount Clicked',
  ExtendClicked: 'Trial: Extend Clicked',
} as const;

const BannerNames = {
  ExploreBenefits: 'Explore Benefits',
  MidTrial: 'Mid Trial Modal', // shown halfway through the trial
  TrialEnded: 'Trial Ended',
  Survey: 'Survey', // after the trial ended modal
  NotEnoughFeatures: 'Not Enough Features', // after the trial ended modal
  Discount: 'Discount', // after the trial ended modal
  Extend: 'Extend', // after the trial ended modal
} as const;

const CTALocations = {
  RenderCounter: 'Render Counter',
  Sidebar: 'Sidebar',
} as const;

type Event = keyof typeof Events;

type EventProperties = Record<string, string | boolean | number>;

type BannerProperties = {
  banner_name: keyof typeof BannerNames;
} & EventProperties;

type SurveyProperties = {
  reason: string;
} & EventProperties;

function useTrackTrialEvent() {
  const { track } = useEvent();
  function trackTrialEvent(event: 'BannerShown' | 'BannerClosed', properties: BannerProperties): void;
  function trackTrialEvent(
    event: 'FeedbackConverted' | 'FeedbackChurn' | 'FeedbackNotEnoughFeatures',
    properties: SurveyProperties
  ): void;
  function trackTrialEvent(event: 'ApplyDiscountClicked', properties: EventProperties): void;
  function trackTrialEvent(event: 'ExtendClicked', properties: EventProperties): void;
  function trackTrialEvent(event: Event, data: EventProperties): void {
    const { banner_name, cta_location, ...rest } = data;
    const refinedData: EventProperties = { ...rest };

    if (data.banner_name) refinedData.banner_name = BannerNames[data.banner_name as keyof typeof BannerNames];
    if (data.cta_location) refinedData.cta_location = CTALocations[data.cta_location as keyof typeof CTALocations];

    track(Events[event], refinedData);
  }

  return trackTrialEvent;
}

export default useTrackTrialEvent;
